var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCircleArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.534 6.188C10.073 2.651 14.93.456 20.324.456c10.786 0 19.5 8.732 19.5 19.513 0 10.78-8.714 19.512-19.5 19.512-9.104 0-16.694-6.22-18.866-14.634h5.076c2.001 5.683 7.42 9.756 13.79 9.756 8.077 0 14.642-6.561 14.642-14.634 0-8.074-6.565-14.635-14.643-14.635-4.051 0-7.663 1.683-10.299 4.342l7.859 7.854H.799V.456l5.735 5.732Z"
})));
export default SvgCircleArrow;